// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4c0b21e3","239":"68134884","453":"aef1b99c","455":"47011827"}[chunkId] + ".chunk.js";
};